import { DependencyList, useEffect } from 'react'

export const useKeyboard = (
    key: string,
    fn: (k: string) => void,
    deps: DependencyList = [],
    target: any = document
) => {
    useEffect(() => {
        if (!target) return
        const handler = (event: KeyboardEvent) => {
            if (key === event.key) fn(event.key)
        }
        target.addEventListener('keydown', handler)
        return () => target.removeEventListener('keydown', handler)
    }, [target, ...deps])
}
